import { IApiQueryOptions } from 'api/ApiClient';
import { ICancelPayoutOptions } from 'types';

export enum Payouts {
  GET_SITE_PAYOUTS_REQUEST = '@payouts/GET_SITE_PAYOUTS_REQUEST',
  GET_SITE_PAYOUTS_SUCCESS = '@payouts/GET_SITE_PAYOUTS_SUCCESS',
  GET_SITE_PAYOUTS_FAIL = '@payouts/GET_SITE_PAYOUTS_FAIL',

  GET_SITE_EMPLOYEE_PAYOUTS_REQUEST = '@payouts/GET_SITE_EMPLOYEE_PAYOUTS_REQUEST',
  GET_SITE_EMPLOYEE_PAYOUTS_SUCCESS = '@payouts/GET_SITE_EMPLOYEE_PAYOUTS_SUCCESS',
  GET_SITE_EMPLOYEE_PAYOUTS_FAIL = '@payouts/GET_SITE_EMPLOYEE_PAYOUTS_FAIL',

  GET_SITE_REVIEW_PAYOUTS_REQUEST = '@payouts/GET_SITE_REVIEW_PAYOUTS_REQUEST',
  GET_SITE_REVIEW_PAYOUTS_SUCCESS = '@payouts/GET_SITE_REVIEW_PAYOUTS_SUCCESS',
  GET_SITE_REVIEW_PAYOUTS_FAIL = '@payouts/GET_SITE_REVIEW_PAYOUTS_FAIL',

  GET_SITE_REVIEW_PAYOUTS_COUNT_REQUEST = '@payouts/GET_SITE_REVIEW_PAYOUTS_COUNT_REQUEST',
  GET_SITE_REVIEW_PAYOUTS_COUNT_SUCCESS = '@payouts/GET_SITE_REVIEW_PAYOUTS_COUNT_SUCCESS',
  GET_SITE_REVIEW_PAYOUTS_COUNT_FAIL = '@payouts/GET_SITE_REVIEW_PAYOUTS_COUNT_FAIL',

  GET_EMPLOYEE_PAYOUTS_REQUEST = '@payouts/GET_EMPLOYEE_PAYOUTS_REQUEST',
  GET_EMPLOYEE_PAYOUTS_SUCCESS = '@payouts/GET_EMPLOYEE_PAYOUTS_SUCCESS',
  GET_EMPLOYEE_PAYOUTS_FAIL = '@payouts/GET_EMPLOYEE_PAYOUTS_FAIL',

  GET_USER_PAYOUTS_REQUEST = '@payouts/GET_USER_PAYOUTS_REQUEST',
  GET_USER_PAYOUTS_SUCCESS = '@payouts/GET_USER_PAYOUTS_SUCCESS',
  GET_USER_PAYOUTS_FAIL = '@payouts/GET_USER_PAYOUTS_FAIL',

  RETRY_PAYOUT_REQUEST = '@payouts/RETRY_PAYOUT_REQUEST',
  RETRY_PAYOUT_SUCCESS = '@payouts/RETRY_PAYOUT_SUCCESS',
  RETRY_PAYOUT_FAIL = '@payouts/RETRY_PAYOUT_FAIL',

  CANCEL_PAYOUT_REQUEST = '@payouts/CANCEL_PAYOUT_REQUEST',
  CANCEL_PAYOUT_SUCCESS = '@payouts/CANCEL_PAYOUT_SUCCESS',
  CANCEL_PAYOUT_FAIL = '@payouts/CANCEL_PAYOUT_FAIL',
}

export interface IGetSitePayouts {
  siteId: string;
  options?: IApiQueryOptions;
}

export interface IGetSiteEmployeePayouts extends IGetSitePayouts {
  employeeId: string;
}

export interface IGetEmployeePayouts {
  employeeId: string;
  options?: IApiQueryOptions;
}

export interface IRetryPayout {
  payoutId: string;
  onSuccess?: () => void;
}

export interface ICancelPayout extends IRetryPayout {
  body: ICancelPayoutOptions;
}
